import React, { useContext, useState, useEffect } from "react";
import { Button, Modal, Spinner, Col, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { createAccount } from "../contract functions/helper";
import { LoginContext } from "../../context/LoginContext";

import { getUserCount, getUser, createUser } from "../apis/APICalls";



function LoginModel(props) {
  const [showRegisterModel, setShowRegisterModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useContext(LoginContext);

  //check already login
  useEffect(() => {
    let data = sessionStorage.getItem("userData");
    setLoginData(JSON.parse(data));
  }, []);

  const toggleRegisterModel = () => {
    if (showRegisterModel)
      setShowRegisterModel(false);
    else
      setShowRegisterModel(true);
  }

  const isPresent = async (_email) => {
    let condition = {
      email: _email
    };
    let response = await getUserCount(condition);
    console.log(response);
    if (response.count > 0) {
      return true;
    } else
      return false;
  }

  const handleSubmitCreateAccount = async (event) => {
    event.preventDefault();
    setLoading(true);
    // console.log(event.target)
    if (await isPresent(event.target.formBasicEmail.value)) {
      alert("User with given email is already present!");
      setLoading(false);
      return;
    }
    //Create Wallet
    var formData = await createAccount();
    formData.email = event.target.formBasicEmail.value;
    formData.password = event.target.formBasicPassword.value;
    //Add into database
    let response = await createUser(formData);
    console.log(response)
    alert("Account created Sucessfully!");
    setShowRegisterModel(false);
    setLoading(false);
  }

  const handleSubmitLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    // console.log(event.target)
    // check login with email and password
    let credentials = {
      email: event.target.formBasicEmail.value,
      password: event.target.formBasicPassword.value
    }
    let response = await getUser(credentials);
    console.log(response)
    if (response.success) {
      // set login Data
      setLoginData(response.data);
      toast.success("Login Sucessful!");
      sessionStorage.setItem("userData", JSON.stringify(response.data));
      props.onHide();
    } else {
      toast.error("No User found with this username and password!");
    }
    setLoading(false);
  }

  return (
    <Modal {...props} dialogClassName="modal-90w" aria-labelledby="contained-modal-title-vcenter" centered >

      {loading ?
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {showRegisterModel ? "Registration" : "Login"}
          </Modal.Title>
        </Modal.Header>
        : <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {showRegisterModel ? "Registration" : "Login"}
          </Modal.Title>
        </Modal.Header>

      }

      <Modal.Body>
        {loading ?
          <div className={loading ? '' : 'hide'} style={{ textAlign: "center" }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <h4>Authenticating User</h4>
          </div>
          :
          <Form onSubmit={showRegisterModel ? handleSubmitCreateAccount : handleSubmitLogin}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
              <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" placeholder="Password" />
            </Form.Group>
            <Button variant="primary" type="submit">
              {showRegisterModel ? "Register" : "Login"}
            </Button>
            <Button variant="secondary" style={{ float: "right" }} onClick={toggleRegisterModel}>
              {showRegisterModel ? "Login" : "Create New Account"}
            </Button>
          </Form>
        }
      </Modal.Body>

    </Modal>
  );
}

export default LoginModel